interface Props {
  stroke?: string;
  radius?: number;
  percent?: number;
  strokeWidth?: number;
}

const Circle = ({
  radius = 70,
  percent = 0,
  stroke = 'white',
  strokeWidth = 3,
}: Props) => {
  const normalizedRadius = radius - strokeWidth + 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percent / 100) * circumference;

  return (
    <svg
      width={radius * 2}
      height={radius * 2}
    >
      <circle
        fill="transparent"
        stroke={stroke}
        strokeDasharray={`${circumference} ${circumference}`}
        strokeWidth={strokeWidth}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        style={{
          strokeDashoffset,
          transition: 'all 500ms',
          transform: 'rotate(-90deg)',
          transformOrigin: '50% 50%',
        }}
      />
    </svg>
  );
};

export default Circle;
